import { getImageProps } from 'next/image';

import { SPIN_ASSETS } from '@/app/lcv/components/campaigns/big-campaign-2026/constants';

const BG_IMAGE = { alt: '', fill: true, sizes: '100vw' } as const;

const BG_DESKTOP_PROPS = getImageProps({
  ...BG_IMAGE,
  src: SPIN_ASSETS.backgroundDesktop,
}).props;

export const BG_DESKTOP_SRC_SET = BG_DESKTOP_PROPS.srcSet;

export const BG_MOBILE_PROPS = getImageProps({
  ...BG_IMAGE,
  src: SPIN_ASSETS.backgroundMobile,
  priority: true,
}).props;

export const preloadSpinBackground = () => {
  const isDesktop = window.matchMedia('(min-width: 1024px)').matches;
  const image = new Image();
  image.sizes = BG_IMAGE.sizes;
  if (isDesktop) {
    image.srcset = BG_DESKTOP_SRC_SET ?? '';
    image.src = BG_DESKTOP_PROPS.src;
    return;
  }
  image.srcset = BG_MOBILE_PROPS.srcSet ?? '';
  image.src = BG_MOBILE_PROPS.src;
};
